module.exports = __webpack_public_path__ + "static/wojciech_oleksiak@x2-89b47b99d6986687789108990293f8e7.jpg";